//jshint multistr: true
/**
 *
 * Service: reportsGenerator
 */
angular.module('acme.common.service.reports.generator', [
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.calendar'
])
.service('ReportsGeneratorService', [ '$q', '$filter', '$timeout', 'HelpersService', 'ValidateService', 'CalendarService', function($q, $filter, $timeout, HelpersService, ValidateService, CalendarService) {

    return {

      type: '',
      markup: '',
      progress: 0,
      partName: 'generating',
      numericColumns: {},

      init: function(config) {

        if (config.type) {
          this.type = config.type.toLowerCase();
        }

        if (config.progress) {
          this.progress = config.progress;
        }

        this.markup = '';

      },

      generate: function(report) {

        var q = $q.defer(),
            self = this;

        if (this.type) {
          this[this.type](report).then(function(markup) {
            self.markup = markup;
            q.resolve(self.markup);
          });
        }else{
          // Must return a promise
          this.markup = '';
          $timeout(function() {
            q.resolve(self.markup);
            return true;
          }, 30);
        }

        return q.promise;

      },

      isNumeric: function(value, field) {
        var r = (ValidateService.validators.number(value));

        if (r && !this.numericColumns[field]) {
          // Only set to true if it is possible
          this.numericColumns[field] = r;
        }else if (this.numericColumns[field]) {
          r = true;
        }

        return r;
      },

      isUTCDate: function(date) {
        return ValidateService.validators.utcDate(date);
      },

      getDisplayDate: function(date) {
        var _date = date;
        if (this.isUTCDate(date)) {
          _date = $filter('date')(CalendarService.parseDate(date), HelpersService.dateFormats.sortDateTime);
        }
        return _date;
      },

      thead: function(group, columns) {

        var j, jj,
            tmp,
            r = '';

        r += '<thead> \
                <tr>';
        for (j=0,jj=columns.length;j<jj;j++) {
          r += '<th';

          tmp = '';

          if (group.name === columns[j].field) {
            tmp += 'reports-print-summary-hide-column ';
          }

          if (this.numericColumns[columns[j].field]) {
            tmp += 'reports-print-subtotal-num';
          }

          if (tmp.length) {
            tmp = ' class="' + tmp + '"';
          }

          r += tmp + '> \
                  <span>' + columns[j].displayName + '</span> \
                </th>';

        }

        r += '</tr> \
            </thead>';

        return r;

      },

      tbody: function(group, columns, type) {
        var tmp,
            c = 0,
            r = '',
            self = this;


        r += '<tbody>';

        angular.forEach(group.values, function(row, key) {

          var i, ii;

          if (row) {
            r += '<tr>';

            for (i = 0, ii = columns.length; i < ii; i++) {

              tmp = '';

              r += '<td';

              if (type === 'full') {
                if (self.isNumeric(row[columns[i].field], columns[i].field)) {
                  tmp += 'reports-print-subtotal-num ';
                }

                if (c > 0) {
                  tmp += 'reports-print-line';
                }
              }else if (type === 'summary') {
                if (self.isNumeric(row[columns[i].field], columns[i].field)) {
                  tmp += 'reports-print-subtotal-num ';
                }

                if (columns[i].field !== 'undefined' && c > 0 && i > 0) {
                  tmp += 'reports-print-line ';
                }

                if (row.subtotal &&
                    row.fields.indexOf(columns[i].field) === -1) {
                  tmp += 'reports-print-subtotal ';
                }
              }

              if (tmp.length) {
                tmp = ' class="' + tmp + '"';
              }

              r += tmp + '>';

              if ((group.value !== row[columns[i].field]) || row.subtotal) {
                switch (columns[i].type) {
                  case 'date':
                    r += '<span>' + self.getDisplayDate(row[columns[i].field]) + '</span>';
                    break;
                  case 'currency':
                    if (row[columns[i].field]) {
                      r += '<span>' + $filter('currency')(row[columns[i].field]) + '</span>';
                    }
                    break;
                  default:
                    r += '<span>' + row[columns[i].field] + '</span>';
                }
              }
            }

            r += '</td> \
                </tr>';

            c++;
          }
        });

        r += '<tr> \
                <td class="reports-print-summary-divider" colspan="' + columns.length + '"></td> \
              </tr> \
            </tbody>';

        return r;
      },

      tfoot: function(group, columns, totals, type) {

        var i, ii,
            r = '';

        r += '<tfoot>';

        if (totals) {
          r += '<tr> \
                    <td colspan="' + columns.length + '" class="reports-print-grand-total-spacer">&nbsp;</td> \
                  </tr> \
                  <tr> \
                    <td class="reports-print-grand-total"' + ((type === 'summary') ? ' colspan="' + (columns.length - group.highlightWidth) + '"' : '') + '>Grand Total</td>';
          for (i = 0, ii = columns.length; i < ii; i++) {
            if (totals[columns[i].field]) {
              r += '<td class="reports-print-grand-total';

              if (this.isNumeric(totals[columns[i].field])) {
                r += ' reports-print-subtotal-num';
              }

              r += '">';

              switch (columns[i].type) {
                case 'date':
                  r += '<span>' + this.getDisplayDate(totals[columns[i].field]) + '</span>';
                  break;
                case 'currency':
                  if (totals[columns[i].field]) {
                    r += '<span>' + $filter('currency')(totals[columns[i].field]) + '</span>';
                  }
                  break;
                default:
                  r += '<span>' + totals[columns[i].field] + '</span>';
              }

              r += '</td>';
            }
          }

          r += '</tr>';
        }

        r += '<tr> \
                <td colspan="' + columns.length + '" class="reports-print-grand-total-spacer">&nbsp;</td> \
              </tr>';

        if (group.totalRecords) {
          r += '<tr> \
                  <td colspan="' + columns.length + '" class="reports-print-grand-total"> \
                    <span>Total Records: ' + group.totalRecords + '</span> \
                  </td> \
                </tr>';

        }

        r += '</tfoot>';

        return r;
      },

      emptyReport: function(group, columns) {

        var i, ii,
            tmp,
            r = '';

        r += '<table> \
                <thead> \
                <tr>';

        for (i = 0, ii = columns.length; i < ii; i++) {
          r += '<th';
          tmp = '';

          if (group.name === columns[i].field) {
            tmp += 'reports-print-summary-hide-column ';
          }

          if (this.numericColumns[columns[i].field]) {
            tmp += 'reports-print-subtotal-num';
          }

          if (tmp.length) {
            tmp = ' class="' + tmp + '"';
          }

          r += tmp + '> \
                <span>' + columns[i].displayName + '</span> \
              </th>';

        }

        r += '</tr> \
            </thead> \
            <tbody> \
              <tr> \
                <td class="text-center" colspan="' + columns.length + '"> No items found. </td> \
              </tr> \
            </tbody> \
            <tfoot> \
              <tr> \
                <td colspan="' + columns.length + '" class="reports-print-grand-total-spacer">&nbsp;</td> \
              </tr> \
              <tr> \
                <td colspan="' + columns.length + '" class="reports-print-grand-total"> \
                  <span>Total Records: 0</span> \
                </td> \
                </tr> \
                </tfoot> \
              </table>';

        return r;

      },

      full: function (report) {

        var i = 0,
            r = '',
            thead = '',
            tbody = '',
            tfoot = '',
            self = this,
            q = $q.defer(),
            keys = Object.keys(report.data);

        this.progress.setValue(this.partName, i);

        angular.forEach(report.data, function(group, key) {

          $timeout(function() {

            r += '<div class="reports-print-summary full">';

            if (group.values instanceof Array && group.values.length) {
              r += '<table>';


              tbody = self.tbody(group, report.grid.columns, 'full');


              // thead is defined after tbody so numericColumns are populated for the headings
              thead = self.thead(group, report.grid.columns);

              // Last key
              if (key + "" === keys[keys.length - 1]) {
                // tfoot is defined after tbody so numericColumns are populated for the headings
                tfoot = self.tfoot(group, report.grid.columns, report.totals, 'full');
              }

              // End table
              r += thead + tbody + tfoot + '</table> \
                </div>';
            }else{

              r += self.emptyReport(group, report.grid.columns);
              r += '</div>';
            }

            i++;

            self.progress.setValue(self.partName, Math.abs(i / keys.length) * 100);

            if (keys.length === i) {
              q.resolve(r);
            }

            return true;

          }, 30);

        });

        return q.promise;
      },

      summary: function(report) {
        var i = 0,
            r = '',
            thead = '',
            tbody = '',
            tfoot = '',
            self = this,
            q = $q.defer(),
            keys = Object.keys(report.data);

        this.progress.setValue(this.partName, i);

        angular.forEach(report.data, function(group, key) {

          $timeout(function() {

            r += '<div class="reports-print-summary"> \
                <h4>' + group.name + ': <b>' + group.value + '</b></h4>';

            if (group.values instanceof Array && group.values.length) {
              r += '<table>';

              tbody = self.tbody(group, report.grid.columns, 'summary');
              // thead is defined after tbody so numericColumns are populated for the headings
              thead = self.thead(group, report.grid.columns);

              // Last key
              if (key + "" === keys[keys.length - 1]) {
                // tfoot is defined after tbody so numericColumns are populated for the headings
                tfoot = self.tfoot(group, report.grid.columns, report.totals, 'summary');
              }

              // End table
              r += thead + tbody + tfoot + '</table> \
                </div>';
            }else{

              r += self.emptyReport(group, report.grid.columns);

            }

            i++;

            self.progress.setValue(self.partName, Math.abs(i / keys.length) * 100);

            if (keys.length === i) {
              q.resolve(r);
            }

            return true;

          }, 30);

        });

        return q.promise;
      }

    };

}]);
